import api from 'axios';

export interface HistorySummary {
  imports: number;
  products: number;
  cnpjs: number;
  suppliers: number;
  total_saida: number;
  total_entrada: number;
  avg_stock: number;
  rupturas: number;
  avg_coverage: number;
  avg_cmd: number;
  snapshots: number;
  date_from?: string;
  date_to?: string;
}

export interface HistorySeriesPoint {
  period: string;
  total_saida: number;
  total_entrada: number;
  avg_stock: number;
  rupturas: number;
  avg_coverage: number;
}

export interface HistoryProduct {
  ean: string;
  produto: string;
  foto?: string;
  industria?: string;
  cnpjs: number;
  imports: number;
  total_saida: number;
  total_entrada: number;
  avg_stock: number;
  latest_stock: number;
  first_stock: number;
  min_stock: number;
  max_stock: number;
  avg_cmd: number;
  avg_coverage: number;
  stock_variation: number;
  sales_share: number;
  last_reference: string;
}

export interface HistoryImport {
  import_id: number;
  status: 'processing' | 'completed' | 'partial' | 'failed';
  source_files: string[];
  reference_start?: string;
  reference_end?: string;
  total_received: number;
  total_valid: number;
  total_invalid: number;
  supplier_count: number;
  created_at: string;
  completed_at?: string;
}

export interface HistoryData {
  summary: HistorySummary;
  series: HistorySeriesPoint[];
  status_distribution: Array<{label: string; value: number}>;
  products: HistoryProduct[];
  suppliers: Array<{label: string; supplier_id?: number; product_count: number; total_saida: number; avg_stock: number; avg_coverage: number}>;
  seasonality: Array<{period: number; total_saida: number; avg_stock: number; products: number}>;
  imports: HistoryImport[];
  filters: {
    cnpjs: string[];
    products: Array<{ean: string; produto: string}>;
    suppliers: Array<{supplier_id: number; fornecedor: string}>;
    dates: {from?: string; to?: string};
  };
  granularity: 'day' | 'week' | 'month';
}

export interface HistoryParams {
  date_from?: string;
  date_to?: string;
  cnpj?: string;
  ean?: string;
  supplier_id?: string;
  search?: string;
  granularity?: 'day' | 'week' | 'month';
}

export async function fetchStockHistory(params: HistoryParams): Promise<HistoryData> {
  const response = await api.get<{success: boolean; data: HistoryData; error?: string}>(
    '/sellers/stock-intelligence/history',
    {params}
  );
  if (!response.data.success) throw new Error(response.data.error || 'Não foi possível carregar o histórico.');
  return response.data.data;
}

